import { MedicalEvent } from '../model/MedicalEvent'

export const hasDocOrFile = (medicalEvent: MedicalEvent) =>
  medicalEvent.documents.length > 0 || medicalEvent.files.length > 0
